import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";

const Writings = () => {
  const posts = [
    {
      id: "simulation",
      title: "simulation",
      excerpt: "the secret to simulation 🤫",
      date: "2026-07-05",
    },
    {
      id: "person",
      title: "the person you want to surround yourself with",
      excerpt: "there is an objective good human being!! i really want to be that way",
      date: "2026-05-10",
    },
    {
      id: "logging",
      title: "what i learned from logging everyday of my life for 4 years",
      excerpt: "w.i.p",
      date: "2026-04-28",
    },
    {
      id: "stanford",
      title: "a stanford essay i liked",
      excerpt: "you have no original thoughts :DD",
      date: "2026-01-05",
    },
  ];

  return (
    <div className="blog">
      <div className="container">
        <div className="content">
          <Link to="/" className="back-link">
            ← back
          </Link>
          <h1>writings</h1>
          <div className="blog-list">
            {posts.map((post) => (
              <Link
                key={post.id}
                to={`/writings/${post.id}`}
                className="blog-post-link"
              >
                <div className="blog-post">
                  <h2>{post.title}</h2>
                  <p className="blog-excerpt">{post.excerpt}</p>
                  <p className="blog-date">{post.date}</p>
                </div>
              </Link>
            ))}
          </div>
          <p className="blog-dm-text">pls reach out and roast my writing if it resonated</p>
        </div>
      </div>
    </div>
  );
};

export default Writings;
